// Legacy code ran each time its classic <script> did: while the page parsed, and again when a
// Turbo visit (a Turbo-submitted form that redirects, or Turbo.visit) re-ran the scripts in the
// new <body>. A module runs once per document, so code that sets up the page registers here: it
// runs now, and again each time Turbo re-runs the legacy bundle for a page it rendered.
const callbacks = [];

document.addEventListener('legacy-bundle:application', () => {
  callbacks.forEach((callback) => callback());
});

export const onPageLoad = (callback) => {
  callbacks.push(callback);
  callback();
};
